<template>
    <div>
<!--        <div class="h-crumbOut">-->
<!--            <div class="h-crumbs">-->
<!--                <el-breadcrumb separator="|">-->
<!--                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
<!--                    <el-breadcrumb-item>套餐场景维护</el-breadcrumb-item>-->
<!--                </el-breadcrumb>-->
<!--            </div>-->
<!--        </div>-->
      <Breadtabsheader/>
        <div class="h-content">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                            <el-form-item label="链群" style="width: 25%;">
                                <brselect placeholder="请选择"
                                          category="xsyb_lianqun"
                                          :v="formInline.lianqunCode"
                                          clearable
                                          v-model="formInline.lianqunCode">
                                </brselect>
                            </el-form-item>
                            <el-form-item label="场景" style="width: 25%;">
                                <el-input v-model="formInline.sceneName" placeholder="请输入场景名称"></el-input>
                            </el-form-item>
                            <el-form-item label="状态" style="width: 25%;">
                                <el-select v-model="formInline.status" placeholder="请选择">
                                    <el-option label="禁用" value="0"></el-option>
                                    <el-option label="正常" value="1"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="checkData">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            <el-button class="h-btn h-formBtn h-bggreen h-mr20" icon="el-icon-plus" style="width:2rem;"@click="createPackage">
                                套餐场景新增
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-row purchaselist">
                <div class="h-rowIn" style="width:100%;">
                    <el-table
                            ref="multipleTable"
                            @selection-change="handleSelectionChange"
                            :data="tableData"
                            stripe
                            style="width: 100%"
                            :border="true"
                            max-height="100%"
                    >
                        <el-table-column
                                type="selection"
                                width="40"
                                fixed
                        >
                        </el-table-column>
                        <el-table-column
                                type="index"
                                width="40"
                                label="#"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="lianqunName"
                                label="链群"
                                :show-overflow-tooltip="true"
                                min-width="25%"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="sceneCode"
                                label="场景编码"
                                :show-overflow-tooltip="true"
                                min-width="25%"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="sceneName"
                                label="场景"
                                :show-overflow-tooltip="true"
                                min-width="25%"
                        >
                        </el-table-column>

                        <el-table-column
                                prop="status"
                                label="状态"
                                :show-overflow-tooltip="true"
                                min-width="25%"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">禁用</span>
                                <span v-if="scope.row.status == 1">正常</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="isQuality"
                                label="是否质量审批"
                                :show-overflow-tooltip="true"
                                min-width="25%"
                        >
                            <template slot-scope="scope">
                                <span v-if="scope.row.isQuality == 0">否</span>
                                <span v-if="scope.row.isQuality == 1">是</span>
                            </template>
                        </el-table-column>
                        <el-table-column
                                prop="cuname"
                                label="创建人"
                                min-width="25%"
                                :show-overflow-tooltip="true"
                        >
                        </el-table-column>
                        <el-table-column
                                prop="cdate"
                                :show-overflow-tooltip="true"
                                label="创建时间"
                                :formatter="formatDate"
                                min-width="25%"
                        >
                        </el-table-column>
                        <el-table-column
                                label="操作"
                                :show-overflow-tooltip="true"
                                fixed="right"
                                min-width="25%"
                        >
                            <template slot-scope="scope">
                                <div style="text-align: left;">
                                    <el-button
                                            v-if="scope.row.status == 1"
                                            type="text"
                                            size="small"
                                            @click="banScene(scope.row.id,'禁用')"
                                            class="h-tableLink h-btn">
                                        禁用
                                    </el-button>
                                    <el-button
                                            v-if="scope.row.status == 0"
                                            type="text"
                                            size="small"
                                            @click="banScene(scope.row.id,'启用')"
                                            class="h-tableLink h-btn">
                                        启用
                                    </el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="h-tableB h-mrt30">
                        <div class="h-tableBL">
                            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="exportExcel">批量导出</el-button>
                        </div>
                        <div class="h-pagination2">
                            <pagination :page="q" @query="query"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :close-on-click-modal="false" :visible.sync="packageSceneVisible" class="h-dialog2 wuliu">
            <div class="h-dialogImg">
                <div class="h-disTable">
                    <div class="h-tableCell">
                        <h1>套餐场景维护</h1>
                    </div>
                </div>
            </div>
            <div class="h-formLine">
                <el-form :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
                    <el-form-item  label="链群" prop="lianqunCode" class="h-elformWrap-2" style="width: 100%;">
                        <brselect placeholder="请选择"
                                  category="xsyb_lianqun"
                                  :v="add.lianqunCode"
                                  clearable
                                  v-model="add.lianqunCode">
                        </brselect>
                    </el-form-item>
                    <el-form-item label="场景" class="h-elformWrap-2" style="width: 100%;">
                        <el-input v-model="add.sceneName" placeholder="请填写场景名称"></el-input>
                    </el-form-item>
                    <el-form-item label="是否质量审批" required class="h-elformWrap-2" style="width: 100%;">
                        <el-select v-model="add.isQuality" :clearable="true">
                            <el-option label="是" value="1"></el-option>
                            <el-option label="否" value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancelScene">取 消</el-button>
                <el-button type="primary" @click="createScene">确 定</el-button>
            </div>
        </el-dialog>
        <!--地址信息-->
        <areaSelect
                :visible.sync="showdizhiflag"
                v-if="showdizhiflag"
                @choseObj="choseDizhi"
        />
    </div>
</template>
<script>
    import ss from '../../api/SystemService'
    import updownfile from '../../utils/updownfile'
    import uploaddownexcel from '../../components/uploaddown/uploaddownexcel'
    export default {
        components: {
            uploaddownexcel,
        },
        data(){
            return{
                formInline:{
                    lianqunCode:null,
                    lianqunName:null,
                    sceneName:'',
                    status:'1',
                },
                q:{
                    lianqunCode:null,
                    lianqunName:null,
                    sceneName: '',
                    status:'1',
                    pageSize:10,
                    pageNo:1,
                    total: 0,
                },
                add:{
                    lianqunCode:'',
                    lianqunName:'',
                    sceneName:'',
                    isQuality: null,
                },
                options2:[],
                multipleSelection: [],
                tableData:[],
                packageSceneVisible:false,

            }
        },
        created(){
        },
        handleFilter() {
            this.query();
        },
        methods:{
            //表格
            handleSelectionChange(val) {
                this.multipleSelection = val;
                var str = '';
                var str2 = '';
                this.multipleSelection.forEach(element => {
                    str += element.cgId + ',';
                    str2 += element.code + ',';
                });
                str = str.substring(0,str.length-1);
                str2 = str2.substring(0,str2.length-1);
                this.ddhB = str;
                this.ddhC = str2;
            },
            //检索按钮功能
            checkData(){
                this.q.pageNo = 1;
                this.query();
            },
            //重置按钮功能
            resetData(){
                this.formInline.lianqunName = ""
                this.formInline.sceneName = ""
                this.formInline.status = ""
                this.q.status = ""
                this.q.lianqunName = ""
                this.q.sceneName = ""
                this.q.pageSize = 10;
                this.query();

            },
            query() {
                this.q.lianqunName = this.formInline.lianqunName;
                this.q.lianqunCode = this.formInline.lianqunCode;
                this.q.sceneName = this.formInline.sceneName
                this.q.status = this.formInline.status
                ss.bom.selectScenePage(this.q).then(rd => {
                    this.q.total = rd.total;
                    this.tableData = rd.records;
                });
            },
            //明细导出
            exportExcel() {

                this.q.lianqunName = this.formInline.lianqunName;
                this.q.lianqunCode = this.formInline.lianqunCode;
                this.q.sceneName = this.formInline.sceneName
                this.q.status = this.formInline.status

                updownfile.down("/api/swyl/v1/bom/bomPackageScene/downloadExcel",this.q,"get",'params');

            },
            //新增套餐
            createPackage(){
                this.packageSceneVisible = true;
            },
            //新增方法
            createScene() {
                if(!this.add.isQuality){
                    this.$msg.msge("请选择是否需要质量审批！");
                    return;
                }
                this.$msg.confirm("确认提交该信息?", () => {
                    ss.bom.createScene(this.add).then(rd => {
                        this.packageSceneVisible = false;
                        this.add.lianqunCode = null;
                        this.add.sceneName = null;
                        this.query();
                    })
                });
            },
            banScene(id,flag) {
                var data = {
                    id: '',
                    status:0
                }
                if(flag == '启用'){
                    data.status = 1;
                }
                data.id = id;
                this.$msg.confirm("确认提交该信息?", () => {
                    ss.bom.banScene(data).then(rd => {
                        this.query();
                    })
                });
            },
            cancelScene(){
                this.packageSceneVisible = false;
                this.add.lianqunCode = null;
                this.add.sceneName = null;
            },
            //日期格式化
            formatDate(row, column) {
                // 获取单元格数据
                let data = row[column.property]
                if(data == null) {
                    return null
                }
                let dt = new Date(data)
                return this.$util.riQi3(dt);
            },
        },
        mounted() {
            this.query();
        }
    }
</script>
<style>
    .wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__label{
        width: 25%;
    }
    .wuliu .h-dialogForm .h-elformWrap-2 .el-form-item__content{
        width: 64%;
    }
    .wuliu .h-formbLine .h-elformWrap-2{
        width: 100%!important;
    }
    .purchaselist	.h-tableLink{
        padding:0px!important;
    }
    .h-formbLine .fkinput .el-form-item__content .el-input__inner{
        border: 1px solid #dedede;
    }
    .addDeliveryForm{
        padding: 0.54rem 0.28rem 0 0.25rem;
    }

</style>
<style scoped lang="scss">
    .lj_imgclass{
        position: fixed;
        top: 0;
        left: 0;
        z-index: 999999;
        width: 100%;
        height: 100%;
    }
    .lj_imgclasstt{
        text-align: center;
        padding: 3% 0;
        width: 100%;
        height: 100%;
        overflow-y: auto;
    }
    .el-select .el-tag--small{
        height: 24px !important;
    }
    .el-input--suffix{
        vertical-align: bottom !important;
    }
    .fklistBox{
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 0.14rem;
    }
    .fklists{
        padding: 0 0.05rem;
        margin-left: 0.1rem;
        background: #d9e9f3;
        height: 0.3rem;
        line-height: 0.3rem;
        color: #6d829c;
        margin-bottom: 0.14rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 0.14rem;
    }
    .fklists:hover{
        color: #489cf5;
    }
    .fklists:nth-child(4n+1){
        margin-left: 0;
    }
    .fkcircle{
        width: 0.15rem;
        height: 0.15rem;
        line-height: 0.13rem;
        color: #d0e0ea;
        background: #8dafc5;
        margin-left: 0.08rem;
        cursor: pointer;
        border-radius: 50%;
        font-size: 0.1rem;
        text-align: center;
    }
    .fkBtn{
        width: 0.8rem;
        height: 0.28rem;
        font-size: 0.14rem;
        color: #fff;
        text-align: center;
        line-height: 0.28rem;
        background: #238cfd;
        cursor: pointer;
    }
    .bottomTip{
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }
    .newtext{
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top:0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow:1px 1px 4px #2785E7;
        z-index: 2;
    }
    .leaderBox{
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;
        .leaderbg{
            width: 100%;
            height: 100%;

        }
        .steps{
            position: absolute;
            z-index: 1;

        }
        .step1{
            top: 0.8rem;
            left: 0;
            width: 6rem;
            height: 11.5rem;
        }
        .step2{
            top: 1.63rem;
            right: 6.9rem;
            width: 9.4rem;
            height: 1.9rem;
        }
        .step3{
            width: 2.3rem;
            height: 1.9rem;
            right: 3.7rem;
            top: 1.6rem;
        }
        .step4{
            width: 3rem;
            height: 2.3rem;
            right: 0.7rem;
            top: 1.65rem;
        }
        .step5{
            width: 6.25rem;
            height: 1.3rem;
            right: 0.37rem;
            top: 4.25rem;
        }
        .step6{
            width: 3.9rem;
            height: 1.1rem;
            left: 2.6rem;
            top: 7.1rem;
        }
        .stepbtn{
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0,0,0,0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }
        .closeIt{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
